import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Ruler } from "lucide-react";

const ROWS = [
  ["XS", 86, 68, 66],
  ["S", 92, 74, 68],
  ["M", 98, 80, 70],
  ["L", 106, 88, 72],
  ["XL", 114, 96, 74],
];

// Guide measurements in cm: half-chest (garment laid flat, doubled), waist, length.
export const SizeGuide = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="size-guide-dialog" data-lenis-prevent className="max-w-lg rounded-none bg-bone">
      <DialogHeader>
        <DialogTitle className="font-display text-3xl font-light">Size guide</DialogTitle>
      </DialogHeader>
      <p className="text-sm text-stone">Garment measurements, taken flat in centimetres. Our pieces are cut generously — between sizes, size down.</p>
      <table className="mt-4 w-full border border-line bg-white text-sm" data-testid="size-guide-table">
        <thead className="border-b border-line font-mono text-[11px] uppercase tracking-widest text-stone">
          <tr><th className="p-3 text-left">Size</th><th className="p-3 text-right">Chest</th><th className="p-3 text-right">Waist</th><th className="p-3 text-right">Length</th></tr>
        </thead>
        <tbody>
          {ROWS.map(([s, c, w, l]) => (
            <tr key={s} className="border-b border-line last:border-0">
              <td className="p-3 font-mono">{s}</td>
              <td className="p-3 text-right font-mono">{c} cm</td>
              <td className="p-3 text-right font-mono">{w} cm</td>
              <td className="p-3 text-right font-mono">{l} cm</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="text-xs text-stone">Measurements are a guide and may vary slightly between pieces.</p>
    </DialogContent>
  </Dialog>
);

export const SizeGuideButton = ({ onClick }) => (
  <button type="button" onClick={onClick} data-testid="size-guide-button" className="mt-3 inline-flex items-center gap-2 text-sm text-stone link-underline">
    <Ruler className="h-4 w-4" /> Size guide
  </button>
);
